import { useTranslate } from '@tolgee/react';
import { YOUTUBE } from '../../../../config/constants';
import { Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { setPostDataAttribute } from '../../../../redux/slices/lomavisCreator/lomavisCreator';
import { TagsInput } from 'react-tag-input-component';
import {
  YOUTUBE_AVAILABLE_FOR_KIDS_CHOICES,
  YOUTUBE_CATEGORY_CHOICES,
  YOUTUBE_PRIVACY_STATUS_CHOICES
} from '../contants';
import { AdditionalOptionsFirstComment } from './includes/FirstComment';
import { CreatorVerticalSeparator } from '../include/VerticalSeperator';
import './youtube.styles.css';

export const YoutubeAdditionalOptions: React.FC<any> = ({
  platform = YOUTUBE
}) => {
  const { t } = useTranslate();
  const dispatch = useDispatch();
  const {
    postData: {
      [YOUTUBE]: {
        youtube_tags,
        youtube_title,
        youtube_category,
        youtube_privacy_status,
        youtube_available_for_kids
      }
    }
  } = useSelector((state: any) => state.lomavisCreator);

  const normalizedYoutubeCategory = Number.isFinite(Number(youtube_category))
    ? Number(youtube_category)
    : YOUTUBE_CATEGORY_CHOICES[0].value;
  const normalizedYoutubeAvailableForKids = Number.isFinite(
    Number(youtube_available_for_kids)
  )
    ? Number(youtube_available_for_kids)
    : YOUTUBE_AVAILABLE_FOR_KIDS_CHOICES[0].value;
  const normalizedYoutubePrivacyStatus =
    typeof youtube_privacy_status === 'string' &&
    YOUTUBE_PRIVACY_STATUS_CHOICES.some(
      (choice) => choice.value === youtube_privacy_status
    )
      ? youtube_privacy_status
      : YOUTUBE_PRIVACY_STATUS_CHOICES[0].value;

  return (
    <div className="border border-secondary px-2 py-2 rounded">
      <AdditionalOptionsFirstComment
        platform={platform}
      ></AdditionalOptionsFirstComment>
      <CreatorVerticalSeparator />
      <label htmlFor="youtube-title">
        {t('lomavisCreator.additionalOptions.youtube_title')}
      </label>
      <input
        id="youtube-title"
        type="text"
        value={youtube_title || ''}
        className="form-control form-control-sm"
        maxLength={100}
        onChange={(e) => {
          dispatch(
            setPostDataAttribute({
              platform: YOUTUBE,
              attribute: 'youtube_title',
              value: e.target.value
            })
          );
        }}
      />
      <div className="mt-2" />
      <label htmlFor="youtube-tags">
        {t('lomavisCreator.additionalOptions.youtube_tags')}
      </label>
      <div className="youtube_tags">
        <TagsInput
          value={typeof youtube_tags !== typeof '' ? youtube_tags : []}
          separators={['Enter', ',']}
          onChange={(value) => {
            dispatch(
              setPostDataAttribute({
                platform: YOUTUBE,
                attribute: 'youtube_tags',
                value: [...value]
              })
            );
          }}
          name="youtube-tags"
          classNames={{
            input: 'form-control form-control-sm p-0',
            tag: 'bg-light-success text-black badge p-1 me-1'
          }}
        />
      </div>
        <div className={"text-muted mt-1 small"}>
            {t('lomavisCreator.additionalOptions.youtube_tags_hint')}
        </div>

      <div className="mt-2" />
      <label htmlFor="youtube-category-select">
        {t('lomavisCreator.additionalOptions.youtube_category')}
      </label>
      <Form.Select
        id="youtube-category-select"
        size="sm"
        value={normalizedYoutubeCategory}
        onChange={(e) => {
          dispatch(
            setPostDataAttribute({
              platform: YOUTUBE,
              attribute: 'youtube_category',
              value: Number(e.target.value)
            })
          );
        }}
      >
        {YOUTUBE_CATEGORY_CHOICES.map((choice) => (
          <option key={choice.value} value={choice.value}>
            {t(
              `lomavisCreator.additionalOptions.youtube_category_${choice.label}`
            )}
          </option>
        ))}
      </Form.Select>
      <div className="mt-2" />
      <label htmlFor="youtube-available-for-kids">
        {t('lomavisCreator.additionalOptions.youtube_available_for_kids')}
      </label>
      <Form.Select
        id="youtube-available-for-kids"
        size="sm"
        value={normalizedYoutubeAvailableForKids}
        onChange={(e) => {
          dispatch(
            setPostDataAttribute({
              platform: YOUTUBE,
              attribute: 'youtube_available_for_kids',
              value: Number(e.target.value)
            })
          );
        }}
      >
        {YOUTUBE_AVAILABLE_FOR_KIDS_CHOICES.map((choice) => (
          <option key={choice.value} value={choice.value}>
            {t(
              `lomavisCreator.additionalOptions.youtube_available_for_kids_${choice.label}`
            )}
          </option>
        ))}
      </Form.Select>
      <div className="mt-2" />
      <label htmlFor="youtube-privacy-status">
        {t('lomavisCreator.additionalOptions.youtube_privacy_status')}
      </label>
      <Form.Select
        id="youtube-privacy-status"
        size="sm"
        value={normalizedYoutubePrivacyStatus}
        onChange={(e) => {
          dispatch(
            setPostDataAttribute({
              platform: YOUTUBE,
              attribute: 'youtube_privacy_status',
              value: e.target.value
            })
          );
        }}
      >
        {YOUTUBE_PRIVACY_STATUS_CHOICES.map((choice) => (
          <option key={choice.value} value={choice.value}>
            {t(
              `lomavisCreator.additionalOptions.youtube_privacy_status_${choice.label}`
            )}
          </option>
        ))}
      </Form.Select>
    </div>
  );
};
